import script from "./PrizeWheel.vue?vue&type=script&setup=true&lang=js"
export * from "./PrizeWheel.vue?vue&type=script&setup=true&lang=js"

import "./PrizeWheel.vue?vue&type=style&index=0&id=490db86a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490db86a"]])

export default __exports__